import loadable from '@loadable/component'

export const BoxGrid = loadable(() => import('./BoxGrid'))
export type { BoxGridProps } from './BoxGrid'
